import { useState} from "react";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import Div from "@jumbo/shared/Div";
import LogoutIcon from "@mui/icons-material/Logout";
import {ThemeProvider} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import {useLocation, useNavigate} from "react-router-dom";
import {axios_superadmin, axios_tenant} from "../../../../axios";
import {authUser} from "./fake-db";
import CircularProgress from "@mui/material/CircularProgress";

const AuthUserDropdown = () => {

    const [loading,setLoading] = useState(false);
    const navigate = useNavigate();
    const {theme} = useJumboTheme();
    const location = useLocation();
    const username = location.pathname.startsWith("/superadmin") ? localStorage.getItem("superadmin_username") : localStorage.getItem("tenant_username");
    const mail = location.pathname.startsWith("/superadmin") ? localStorage.getItem("SUPERADMIN_USER_MAIL") : localStorage.getItem("TENANT_USER_MAIL");

    const onLogout = async () => {
        if (location.pathname.startsWith("/superadmin")) {
            setLoading(true);
            await axios_superadmin.post("/superAdmin/logout");
            setLoading(false);

            localStorage.removeItem("TREXO_AUTH_TOKEN");
            localStorage.removeItem("superadmin_username");
            localStorage.removeItem("SUPERADMIN_USER_MAIL");

            navigate("/superAdmin/login");
        } else {
            setLoading(true);
            await axios_tenant.post("/user/logout");
            setLoading(false);
            
            localStorage.removeItem("TENANT_NAME");
            localStorage.removeItem("TENANT_USER_ID");
            localStorage.removeItem("TREXO_TENANT_AUTH_TOKEN");
            localStorage.removeItem("tenant_username");
            localStorage.removeItem("TENANT_USER_MAIL");
            localStorage.removeItem("TENANT_ROLE");
            localStorage.removeItem("ICON");
            sessionStorage.removeItem("sessionId");

            navigate("/login");
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <JumboDdPopover
                triggerButton={
                    <Avatar
                        src=""
                        sizes="small"
                        sx={{boxShadow: 25, cursor: "pointer", backgroundColor: "#CED4DA"}}
                    />
                }
            >
                <Div sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    p: theme => theme.spacing(2.5)
                }}>
                    <Avatar src="" alt={authUser.name} sx={{width: 60, height: 60, mb: 2}}/>
                    <Typography variant="h5">{username}</Typography>
                    <Typography variant="body1" color="text.secondary">{mail}</Typography>
                </Div>
                <Divider/>
                <nav>
                    <List disablePadding sx={{ pb: 1 }}>
                        <ListItemButton 
                            onClick={onLogout} 
                            disabled={loading}
                        >
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                {loading ? <CircularProgress size={20} sx={{ color: "blue" }} /> : <LogoutIcon />}
                            </ListItemIcon>
                            <ListItemText primary="Logout" sx={{ my: 0 }} />
                        </ListItemButton>
                        </List>
                </nav>
            </JumboDdPopover>
        </ThemeProvider>
    );
};


export default AuthUserDropdown;